import React, { useState } from "react";
import { Avatar, FormField } from "@maysoft/common-component-react";

import Helpers from "../../commons/helpers";
import GuestService from "../../services/message/GuestService";

import { IDataComment } from "../../commons/interfaces";
import { showAlert } from "../../providers/AlertProvider";
import { useCommentContext } from "../../providers/CommentProvider";

import "../../styles/comment.css";
import "../../styles/inputComment.css";

interface IGuestInfo {
    userName: string;
    email?: string;
}

const InputComment = ({
    visible,
    isComment,
    dataReplyComment,
    isUpdate,
    onCancelComment,
    isReply,
    updateDone,
    sendMessage,
    updateMessage,
    createGuest,
}: {
    visible: boolean;
    isComment: boolean;
    dataReplyComment: IDataComment;
    isUpdate?: boolean;
    onCancelComment: () => void;
    isReply?: (replyTo: string) => void;
    updateDone?: (updateStatus: boolean) => void;
    sendMessage: (discussionValue: string, replyTo?: string) => void;
    updateMessage?: (messageId: string, discussionValue: string) => void;
    createGuest?: (guestData: any) => void;
}) => {
    const { userLogin, onClickShowProfile } = useCommentContext();

    const [dataReply, setDataReply] = React.useState<IDataComment>({} as IDataComment);
    const [dataComment, setDataComment] = React.useState<IDataComment>({} as IDataComment);
    const [guestInfo, setGuestInfo] = React.useState<IGuestInfo>();

    const getObserve = React.useCallback(() => {
        var observe: any;
        if (window["attachEvent" as any]) {
            observe = function (element: any, event: any, handler: any) {
                element.attachEvent("on" + event, handler);
            };
        } else {
            observe = function (element: any, event: any, handler: any) {
                element.addEventListener(event, handler, false);
            };
        }
        return observe;
    }, []);

    const observeRef = React.useRef(getObserve());
    const observe = observeRef.current;

    const init = () => {
        var text = document.getElementById(`textArea_${dataReplyComment?.id}`)!;
        function resize() {
            // text.style.height = "auto";
            // const height = text.scrollHeight !== 0 ? text.scrollHeight : 31;
            // text.style.height = height + "px";
        }
        function delayedResize() {
            window?.setTimeout(resize, 0);
        }
        observe(text, "change", resize);
        observe(text, "cut", delayedResize);
        observe(text, "paste", delayedResize);
        observe(text, "drop", delayedResize);
        observe(text, "keydown", delayedResize);

        text.focus();
        resize();
    };

    React.useEffect(() => {
        if (isComment) {
            setDataComment({ ...dataReplyComment });
        } else {
            setDataReply({ ...dataReplyComment });
        }
    }, []);

    const onCreateGuest = async () => {
        try {
            const result = await GuestService.create({
                guestName: guestInfo?.userName || "",
                email: "",
                phoneNumber: "",
            });
            let data = {
                userId: result?.id,
                userName: result?.guestName,
            };
            return createGuest && createGuest(data);
        } catch (error) {
            showAlert(Helpers.renderExceptionError(error), "error");
        }
    };

    const handleOnSubmitComment = async (id: string, typeComment: boolean, e?: any) => {
        if (!userLogin) {
            if (!Helpers.isNullOrEmpty(guestInfo?.userName)) {
                e.preventDefault();
                await onCreateGuest();
            }
        } else {
            e.preventDefault();
            submitContent(id, typeComment);
        }
    };

    const submitContent = (id: string, typeComment: boolean) => {
        let data: IDataComment = isComment ? dataComment : dataReply;
        if (typeComment) {
            sendMessage(`${data?.discussionValue}`);
            setDataComment({});
        } else {
            if (isUpdate) {
                updateDone && updateDone(false);
                updateMessage && updateMessage(id, `${data?.discussionValue}`);
            } else {
                isReply && isReply(id);
                sendMessage(`${data?.discussionValue}`, id);
            }
            setDataReply({});
        }
    };

    const handleOnCancelComment = (id: string, typeComment: boolean, e: any) => {
        e.preventDefault();
        onCancelComment();
        if (typeComment) {
            setDataComment({});
        } else {
            setDataReply({});
        }
    };

    const handleOnChangeValueComment = (typeComment: boolean, value: any) => {
        typeComment
            ? setDataComment({
                ...dataComment,
                discussionValue: value,
            })
            : setDataReply({
                ...dataReply,
                discussionValue: value,
            });
    };

    const handleChange = (key: string, value: string) => {
        let data: any = { ...guestInfo };
        data[key] = value;
        setGuestInfo({ ...data });
    };

    const [avatarError, setAvatarError] = useState<boolean>(false);

    const renderActionButton = () => (
        <div className="cr-comment-button">
            <button
                className="cr-button cr-button-secondary"
                onClick={(e) => {
                    handleOnCancelComment(`${dataReplyComment?.id}`, isComment, e);
                }}
            >
                <span>Hủy</span>
            </button>
            <button
                type="submit"
                // method="post"
                style={{ marginLeft: "0.25rem" }}
                className="cr-button cr-button-primary"
                // onClick={() => { handleOnSubmitComment(`${dataReplyComment?.id}`, isComment) }}
                disabled={Helpers.isNullOrEmpty(isComment ? dataComment?.discussionValue : dataReply?.discussionValue)}
            >
                <span>{isComment ? "Bình luận" : isUpdate ? "Lưu Lại" : "Trả lời"}</span>
            </button>
        </div>
    );

    return (
        <div
            onLoad={init}
            style={{
                marginBottom: "8px 0px",
                marginTop: `${isComment ? "" : "16px"}`,
                display: isComment ? "grid" : visible ? "grid" : "none",
                gridTemplateColumns: `${isComment ? "50px" : "40px"} auto`,

            }}
        >
            <div className="cr-avatar-box" onClick={() => {
                onClickShowProfile && onClickShowProfile(userLogin)
            }}>
                {/* <a
                    target="_blank"
                    className="cr-sale-comment-a"
                    style={{ height: "min-content" }}
                    href={`@${(isComment ? dataComment : dataReply)?.userComment?.userId}`} rel="noreferrer"
                > */}
                <Avatar
                    className="cr-avatar"
                    src={userLogin?.avatarUrl}
                    text={userLogin?.fullName || userLogin?.userName}
                    alt={`avatar ${(isComment ? dataComment : dataReply)?.userComment?.userId || " "}`}
                    style={{
                        width: isComment ? 50 : 36,
                        height: isComment ? 50 : 36,
                    }}
                />
                {/* </a> */}
            </div>
            <div id={`divInputComment_${dataReplyComment?.id}`} className="cr-form-box">
                <form
                    className="cr-form"
                    id={`divTextarea_${dataReplyComment?.id}`}
                    onSubmit={(e) => handleOnSubmitComment(`${dataReplyComment?.id}`, isComment, e)}
                >
                    {/* <textarea
                        required
                        rows={1}
                        className="cr-input-area"
                        style={{ height: "31px" }}
                        id={`textArea_${dataReplyComment?.id}`}
                        placeholder="Nhập bình luận của bạn vào đây..."
                        value={(isComment ? dataComment?.discussionValue : dataReply?.discussionValue) || ""}
                        onChange={(event) => {
                            handleOnChangeValueComment(isComment, event.target.value);
                        }}
                    /> */}

                    <FormField
                        multiline
                        variant="outlined"
                        id={`textArea_${dataReplyComment?.id}`}
                        placeholder="Nhập bình luận của bạn vào đây..."
                        value={(isComment ? dataComment?.discussionValue : dataReply?.discussionValue) || ""}
                        onChange={(event) => {
                            handleOnChangeValueComment(isComment, event.target.value);
                        }}
                    />
                    {!userLogin && (
                        <div className="cr-row">
                            <input
                                required
                                className="cr-input"
                                placeholder="Họ và tên"
                                id={`textInput_${dataReplyComment?.id}`}
                                onChange={(event) => handleChange("userName", event.target.value)}
                            />
                            <input
                                required
                                placeholder="Email"
                                className="cr-input"
                                id={`textInput_${dataReplyComment?.id}`}
                                onChange={(event) => handleChange("email", event.target.value)}
                            />
                        </div>
                    )}
                    {isComment
                        ? (
                            Helpers.isNullOrEmpty(dataComment?.discussionValue)
                                ? null
                                : renderActionButton()
                        )
                        : renderActionButton()
                    }
                </form>
            </div>
        </div>
    );
};
export default InputComment;
